import React, {Component} from 'react'
import {Row, Col, ButtonGroup, Button} from "elemental"
import WordPress from "../WordPress"
import swal from "sweetalert"
import shop from "../shop/shop"

class DemoPage extends Component {
   constructor() {
      super()
      this.state = {
         cms: {}
      }

      shop.post("demo").then(post => {
         this.setState({post})
      })
   }


   render() {
      let {post} = this.state
      return (
         <div className="container">
            <section className="padding">
               <Row>
                  <Col className="tc"
                       style={{marginTop: "60px"}}>
                     <h2>UI Inventar (Mini)</h2>
                  </Col>
               </Row>
            </section>

            <section className="padding">
               <div className="row-title">
                  <h2>Buttons</h2>
               </div>
               <Row>
                  <Col sm="1/6"> <Button type="primary"
                                         className="block"> primary </Button></Col>
                  <Col sm="1/6"> <Button type="default"> white </Button></Col>
                  <Col sm="1/6"> <Button type="success"> success </Button></Col>
                  <Col sm="1/6"> <Button type="warning"> warning </Button></Col>
                  <Col sm="1/6"> <Button type="danger"> danger </Button></Col>
                  <Col sm="1/6"> <Button type="link"> link </Button></Col>
               </Row>
               <hr />
               <Row>
                  <Col sm="1/6"> <Button type="hollow-primary"
                                         className="block"> primary </Button></Col>
                  <Col sm="1/6"> <Button type="default"> white </Button></Col>
                  <Col sm="1/6"> <Button type="hollow-success"> success </Button></Col>
                  <Col sm="1/6"> <Button type="hollow-warning"> warning </Button></Col>
                  <Col sm="1/6"> <Button type="hollow-danger"> danger </Button></Col>
               </Row>
               <hr />
               <Row>
                  <Col sm="1/6"> <Button style={{width: "100%"}}
                                         type="primary"> BLOCK </Button></Col>
                  <Col sm="1/6"> <Button style={{width: "100%"}}
                                         type="default"> BLOCK </Button></Col>
                  <Col sm="1/6"> <Button style={{width: "100%"}}
                                         type="success"> BLOCK </Button></Col>
                  <Col sm="1/6"> <Button style={{width: "100%"}}
                                         type="warning"> BLOCK </Button></Col>
                  <Col sm="1/6"> <Button style={{width: "100%"}}
                                         type="danger"> BLOCK </Button></Col>
                  <Col sm="1/6"> <Button style={{width: "100%"}}
                                         type="link"> BLOCK </Button></Col>
               </Row>

               <hr />

               <Row>
                  <Col>
                     <ButtonGroup>
                        <Button type="default">Links</Button>
                        <Button type="default">Mitte</Button>
                        <Button type="default">Rechts</Button>
                     </ButtonGroup>
                  </Col>
               </Row>
            </section>

            <section className="padding">
               <div className="row-title">
                  <h2>Hinweise/Modal</h2>
               </div>
               <Row>
                  <Col sm="1/6"> <Button onClick={() => swal("Fehlermeldung", "Beschreibung", "error")}
                                         type="default"> FEHLER </Button></Col>
                  <Col sm="1/6"> <Button onClick={() => swal("Success", "Beschreibung", "success")}
                                         type="default"> ERFOLG </Button></Col>

                  <Col sm="1/6"> <Button onClick={() => swal("Warnung", "Beschreibung", "warning")}
                                         type="default"> WARNUNG </Button></Col>

                  <Col sm="1/6"> <Button onClick={() => swal({
                     title:             "Eingabe löschen?",
                     text:              "Beschreibung",
                     type:              "info",
                     showCancelButton:  true,
                     confirmButtonText: "Ja, Eingabe löschen",
                     cancelButtonText:  "Zurück",
                     closeOnConfirm:    false,
                     html:              false
                  }, () => {
                     swal("Gelöscht!", "Ihre Eingabe wurde gelöscht.", "success");
                  })}
                                         type="default"> BESTÄTIGUNG </Button></Col>

               </Row>
            </section>


            {/*ICONS*/}
            <section className="padding">
               <div className="row-title">
                  <h2>Icons</h2>
               </div>
               <div id="icons"
                    className="container">
                  <Row>
                     <Col sm="1/4"
                          title="Code: 0xe800"
                          className="the-icons span3"><i className="demo-icon icon-heart-empty"></i>
                        <span className="i-name">icon-heart-empty</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe801"
                          className="the-icons span3"><i className="demo-icon icon-heart"></i>
                        <span className="i-name">icon-heart</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe802"
                          className="the-icons span3"><i className="demo-icon icon-ok"></i> <span className="i-name">icon-ok</span>
                     </Col>
                     <Col sm="1/4"
                          title="Code: 0xe803"
                          className="the-icons span3"><i className="demo-icon icon-cancel"></i>
                        <span className="i-name">icon-cancel</span></Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title="Code: 0xe804"
                          className="the-icons span3"><i className="demo-icon icon-minus"></i>
                        <span className="i-name">icon-minus</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe805"
                          className="the-icons span3"><i className="demo-icon icon-plus"></i>
                        <span className="i-name">icon-plus</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe806"
                          className="the-icons span3"><i className="demo-icon icon-home"></i>
                        <span className="i-name">icon-home</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe807"
                          className="the-icons span3"><i className="demo-icon icon-tags"></i>
                        <span className="i-name">icon-tags</span></Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title="Code: 0xe808"
                          className="the-icons span3"><i className="demo-icon icon-pencil"></i>
                        <span className="i-name">icon-pencil</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe809"
                          className="the-icons span3"><i className="demo-icon icon-down-dir"></i> <span className="i-name">icon-down-dir</span>
                     </Col>
                     <Col sm="1/4"
                          title="Code: 0xe80a"
                          className="the-icons span3"><i className="demo-icon icon-up-dir"></i>
                        <span className="i-name">icon-up-dir</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe80b"
                          className="the-icons span3"><i className="demo-icon icon-left-dir"></i> <span className="i-name">icon-left-dir</span>
                     </Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title="Code: 0xe80c"
                          className="the-icons span3"><i className="demo-icon icon-right-dir"></i> <span className="i-name">icon-right-dir</span>
                     </Col>
                     <Col sm="1/4"
                          title="Code: 0xe80d"
                          className="the-icons span3"><i className="demo-icon icon-tint"></i>
                        <span className="i-name">icon-tint</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe80e"
                          className="the-icons span3"><i className="demo-icon icon-phone"></i>
                        <span className="i-name">icon-phone</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe80f"
                          className="the-icons span3"><i className="demo-icon icon-camera"></i>
                        <span className="i-name">icon-camera</span></Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title="Code: 0xe810"
                          className="the-icons span3"><i className="demo-icon icon-user"></i>
                        <span className="i-name">icon-user</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe811"
                          className="the-icons span3"><i className="demo-icon icon-lock"></i>
                        <span className="i-name">icon-lock</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe812"
                          className="the-icons span3"><i className="demo-icon icon-lock-open"></i> <span className="i-name">icon-lock-open</span>
                     </Col>
                     <Col sm="1/4"
                          title="Code: 0xe813"
                          className="the-icons span3"><i className="demo-icon icon-eye"></i> <span className="i-name">icon-eye</span>
                     </Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title="Code: 0xe814"
                          className="the-icons span3"><i className="demo-icon icon-eye-off"></i>
                        <span className="i-name">icon-eye-off</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe815"
                          className="the-icons span3"><i className="demo-icon icon-tag"></i> <span className="i-name">icon-tag</span>
                     </Col>
                     <Col sm="1/4"
                          title="Code: 0xe816"
                          className="the-icons span3"><i className="demo-icon icon-cog"></i> <span className="i-name">icon-cog</span>
                     </Col>
                     <Col sm="1/4"
                          title="Code: 0xe817"
                          className="the-icons span3"><i className="demo-icon icon-cog-alt"></i>
                        <span className="i-name">icon-cog-alt</span></Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title="Code: 0xe818"
                          className="the-icons span3"><i className="demo-icon icon-basket"></i>
                        <span className="i-name">icon-basket</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe819"
                          className="the-icons span3"><i className="demo-icon icon-resize-full"></i>
                        <span className="i-name">icon-resize-full</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe81a"
                          className="the-icons span3"><i className="demo-icon icon-resize-small"></i>
                        <span className="i-name">icon-resize-small</span></Col>
                     <Col sm="1/4"
                          title="Code: 0xe81b"
                          className="the-icons span3"><i className="demo-icon icon-zoom-in"></i>
                        <span className="i-name">icon-zoom-in</span></Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title="Code: 0xe81c"
                          className="the-icons span3"><i className="demo-icon icon-zoom-out"></i> <span className="i-name">icon-zoom-out</span>
                     </Col>
                     <Col sm="1/4"
                          title="Code: 0xe81d"
                          className="the-icons span3"><i className="demo-icon icon-basket-alt"></i> <span className="i-name">icon-basket-alt</span>
                     </Col>
                     <Col sm="1/4"
                          title="Code: 0xe81e"
                          className="the-icons span3"><i className="demo-icon icon-basket-1"></i> <span className="i-name">icon-basket-1</span>
                     </Col>
                     <Col sm="1/4"
                          title="Code: 0xe81f"
                          className="the-icons span3"><i className="demo-icon icon-truck"></i>
                        <span className="i-name">icon-truck</span></Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-angle-left"></i> <span className="i-name">icon-angle-left</span>
                     </Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-angle-right"></i>
                        <span className="i-name">icon-angle-right</span></Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-angle-up"></i> <span className="i-name">icon-angle-up</span>
                     </Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-angle-down"></i> <span className="i-name">icon-angle-down</span>
                     </Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-circle-empty"></i>
                        <span className="i-name">icon-circle-empty</span></Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-lock-open-alt"></i>
                        <span className="i-name">icon-lock-open-alt</span></Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-dot-circled"></i>
                        <span className="i-name">icon-dot-circled</span></Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-cube"></i>
                        <span className="i-name">icon-cube</span></Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-cubes"></i>
                        <span className="i-name">icon-cubes</span></Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-circle-thin"></i>
                        <span className="i-name">icon-circle-thin</span></Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-toggle-off"></i> <span className="i-name">icon-toggle-off</span>
                     </Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-toggle-on"></i> <span className="i-name">icon-toggle-on</span>
                     </Col>
                  </Row>
                  <Row>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-cart-plus"></i> <span className="i-name">icon-cart-plus</span>
                     </Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-cart-arrow-down"></i>
                        <span className="i-name">icon-cart-arrow-down</span></Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-commenting-o"></i>
                        <span className="i-name">icon-commenting-o</span></Col>
                     <Col sm="1/4"
                          title=""
                          className="the-icons span3"><i className="demo-icon icon-shopping-basket"></i>
                        <span className="i-name">icon-shopping-basket</span></Col>
                  </Row>
               </div>
            </section>


            <section className="padding">
               <div className="row-title">
                  <h2>CMS Element "demo"</h2>
               </div>
               <WordPress page={post}></WordPress>
            </section>

            <section className="padding">
               <div className="row-title">
                  <h2>CMS Element "demo"</h2>
               </div>
               <WordPress page={post}></WordPress>
            </section>


         </div>
      )
   }
}

export default DemoPage



// WEBPACK FOOTER //
// ./src/pages/DemoPage.js